import React from 'react';

import { HrefOrHrefWithParams } from 'next-intl/dist/types/navigation/shared/utils';

import { Link } from '@/i18n/routing';

type ProgramListItemLayoutProps = {
    href?: HrefOrHrefWithParams<'/program/[contentId]'>;
    imageComponent: React.JSX.Element;
    titleComponent: React.JSX.Element;
    showingsSlider?: React.JSX.Element;
    title: string;
};

export function ProgramDefaultListItemLayout(props: ProgramListItemLayoutProps): React.JSX.Element {
    return (
        <div
            className="flex flex-col py-24 space-y-16"
            role="group"
            aria-label={props.title}>
            <div className="relative">
                {props.href && (
                    <Link
                        className="absolute top-0 left-0 h-full w-full cursor-pointer"
                        href={props.href}
                        aria-label={props.title}
                        /*
                         * Prefetch the full page data beyond the loading.js boundaries by setting the prefetch prop to true
                         * (See: https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#2-prefetching)
                         */
                        prefetch={false}
                    />
                )}
                <div className="flex flex-row space-x-[32px]">
                    {/*Trailer & Poster*/}
                    <div className="w-auto select-none pointer-events-none">{props.imageComponent}</div>

                    {/*Title and Details*/}
                    <div className="flex-auto select-none pointer-events-none">{props.titleComponent}</div>
                </div>
            </div>

            {props.showingsSlider ? props.showingsSlider : null}
        </div>
    );
}
